export default __webpack_public_path__ + "static/media/1015.06943495.png";